@if (entityTranslationKey()) {
  <h2>{{ (entityTranslationKey() | bmsTranslate: {count: 1}) + ' ' + ('SETTINGS.MENU_NAME' | bmsTranslate | lowercase) }}</h2>
}

<vdw-tabs-and-actions-header [menuItems]="menuItems()" [selectedMenuItem]="selectedMenuTab()" (selectedMenuItemChange)="updateSelectedTab($event)">
  <button mat-button (click)="cancel.emit()">{{ 'GENERAL.ACTIONS.CANCEL' | bmsTranslate }}</button>
  @if (canShowSave) {
    <button mat-flat-button (click)="save.emit()">{{ ('GENERAL.ACTIONS.SAVE' | bmsTranslate) + ' ' + ('SETTINGS.MENU_NAME' | bmsTranslate | lowercase) }}</button>
  }
</vdw-tabs-and-actions-header>
